import { useState, useEffect } from 'react';
import { getOrgId, organisationsAPI } from '../services/api';

let cacheOrgId: string | null = null;
let cacheName: string | null = null;

/**
 * Resolves current organisation display name (cached per session for same org id).
 * @returns {string|null} null while loading
 */
export function useOrganisationName() {
  const [name, setName] = useState<string | null>(() => (cacheOrgId && cacheName ? cacheName : null));

  useEffect(() => {
    let cancelled = false;
    getOrgId()
      .then((orgId) => {
        if (!orgId) {
          if (!cancelled) setName(null);
          return;
        }
        if (cacheOrgId === orgId && cacheName) {
          if (!cancelled) setName(cacheName);
          return;
        }
        return organisationsAPI.get(orgId).then((org) => {
          if (cancelled) return;
          const n = org && org.name ? String(org.name) : 'Organisation';
          cacheOrgId = orgId;
          cacheName = n;
          setName(n);
        });
      })
      .catch(() => {
        if (!cancelled) setName('Organisation');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return name;
}
